import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Spanish
import esCommon from './locales/es/common.json'
import esAuth from './locales/es/auth.json'
import esDashboard from './locales/es/dashboard.json'
import esFleet from './locales/es/fleet.json'
import esOrders from './locales/es/orders.json'
import esRoutes from './locales/es/routes.json'
import esFreight from './locales/es/freight.json'
import esSettings from './locales/es/settings.json'
import esSecurity from './locales/es/security.json'
import esErrors from './locales/es/errors.json'
import esTraceability from './locales/es/traceability.json'

// English
import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enDashboard from './locales/en/dashboard.json'
import enFleet from './locales/en/fleet.json'
import enOrders from './locales/en/orders.json'
import enRoutes from './locales/en/routes.json'
import enFreight from './locales/en/freight.json'
import enSettings from './locales/en/settings.json'
import enSecurity from './locales/en/security.json'
import enErrors from './locales/en/errors.json'
import enTraceability from './locales/en/traceability.json'

// Portuguese (Brazilian)
import ptCommon from './locales/pt/common.json'
import ptAuth from './locales/pt/auth.json'
import ptDashboard from './locales/pt/dashboard.json'
import ptFleet from './locales/pt/fleet.json'
import ptOrders from './locales/pt/orders.json'
import ptRoutes from './locales/pt/routes.json'
import ptFreight from './locales/pt/freight.json'
import ptSettings from './locales/pt/settings.json'
import ptSecurity from './locales/pt/security.json'
import ptErrors from './locales/pt/errors.json'
import ptTraceability from './locales/pt/traceability.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        dashboard: esDashboard,
        fleet: esFleet,
        orders: esOrders,
        routes: esRoutes,
        freight: esFreight,
        settings: esSettings,
        security: esSecurity,
        errors: esErrors,
        traceability: esTraceability,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        dashboard: enDashboard,
        fleet: enFleet,
        orders: enOrders,
        routes: enRoutes,
        freight: enFreight,
        settings: enSettings,
        security: enSecurity,
        errors: enErrors,
        traceability: enTraceability,
      },
      pt: {
        common: ptCommon,
        auth: ptAuth,
        dashboard: ptDashboard,
        fleet: ptFleet,
        orders: ptOrders,
        routes: ptRoutes,
        freight: ptFreight,
        settings: ptSettings,
        security: ptSecurity,
        errors: ptErrors,
        traceability: ptTraceability,
      },
    },
    defaultNS: 'common',
    fallbackLng: 'es',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'aram_lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
